import * as React from 'react';
import * as Yup from 'yup';
import { FormikProps, FormikActions, Formik } from 'formik';
import Component from '@reach/component-component';

import { IFormikOuterProps } from 'src/views/Admin/types';
import { IParameter, IFormProps, IFormState } from '../types';

import {
  parameterize,
  deparameterize,
} from 'src/views/Admin/services/objectHelpers';
import EditForm from './EditForm';

export default class Form extends React.Component<IFormProps, IFormState> {
  id = this.props.id;

  state: IFormState = {
    error: '',
  };

  schema = Yup.object().shape(
    parameterize(this.id, {
      name: Yup.string().required('Name is required'),
      helpMessage: Yup.string(),
      orderRender: Yup.number(),
      mandatory: Yup.boolean(),
      type: Yup.string(),
    })
  );

  initialValues = parameterize(this.id, this.props.initialValues) as IParameter;

  onSubmit = async (values: IParameter, actions: FormikActions<IParameter>) => {
    this.setState({ error: '' });
    this.props.preventClosing(false);
    await this.props.onSubmit(deparameterize(values) as IParameter);
    actions.setSubmitting(false);
  };

  updateDirty = ({
    prevProps,
    props,
  }: {
    prevProps: IFormikOuterProps;
    props: IFormikOuterProps;
  }) => {
    if (prevProps.dirty !== props.dirty) {
      this.props.preventClosing(props.dirty);
    }
  };

  formRender = (props: FormikProps<IParameter>) => {
    return (
      <EditForm
        error={this.state.error}
        id={this.props.id}
        parameterOptions={this.props.parameterOptions}
        itemOptionsWithParameter={this.props.itemOptionsWithParameter}
        marketOptions={this.props.marketOptions}
        onToggleArchive={this.props.onToggleArchive}
        isArchive={this.props.isArchive}
        {...props}
      >
        <Component dirty={props.dirty} didUpdate={this.updateDirty} />
      </EditForm>
    );
  };

  render() {
    return (
      <Formik
        enableReinitialize={true}
        initialValues={this.initialValues}
        validationSchema={this.schema}
        onSubmit={this.onSubmit}
        render={this.formRender}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/Parameters/components/Form.tsx